
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { useBoardContext } from '@/contexts/BoardContext';
import { Pencil } from 'lucide-react';

interface BoardRenameProps {
  boardId: string;
  currentTitle: string;
}

export const BoardRename = ({ boardId, currentTitle }: BoardRenameProps) => {
  const [isEditing, setIsEditing] = useState(false);
  const [title, setTitle] = useState(currentTitle);
  const { updateBoard, updatingBoard } = useBoardContext();

  const handleSave = () => {
    if (title.trim() && title !== currentTitle) {
      updateBoard({ title: title.trim() });
    }
    setIsEditing(false);
  };

  const handleCancel = () => {
    setTitle(currentTitle);
    setIsEditing(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      handleCancel();
    }
  };

  if (isEditing) {
    return (
      <div className="flex items-center gap-2">
        <Input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={handleSave}
          className="h-7 text-lg font-medium"
          autoFocus
          disabled={updatingBoard}
        />
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 group">
      <h2 className="text-lg font-medium text-gray-700 dark:text-slate-300">
        {currentTitle}
      </h2>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => setIsEditing(true)}
        className="h-6 w-6 p-0 opacity-0 group-hover:opacity-100 transition-opacity"
      >
        <Pencil className="h-3 w-3" />
      </Button>
    </div>
  );
};
